module.exports = __webpack_public_path__ + "static/media/left-menu-playlist-gray.32f93982.svg";